export const deleteWarning = 'Deleting this record will also remove its dependent streams';

export const cameraDeleteWarning = `${deleteWarning}, and stream profiles.`;

export const sourceDeleteWarning = `${deleteWarning} using this stream profile.`;

export const removeDependentStreamsWarning = `${deleteWarning}.`;

export const zoneDeleteWarning = `${deleteWarning} and API Keys.`;

export const contactDeleteWarning = 'Deleting this record will also remove its dependent API Keys.';

export const IPv4 = 4;
export const IPv6 = 6;
